/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'facetemplete-teacher-name': {
    width: 20,
    height: 20,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M22.779 21.083a9.299 9.299 0 0 0 2.555-6.416 9.333 9.333 0 1 0-16.107 6.42l-.004-.004c1.437-2.267 3.933-3.749 6.774-3.749H16.006a7.99 7.99 0 0 1 6.755 3.717l.019.033zM16 31.637l-8.485-8.485A11.962 11.962 0 0 1 4 14.667c0-6.627 5.373-12 12-12s12 5.373 12 12c0 3.314-1.343 6.314-3.515 8.485L16 31.637zM16 16a4 4 0 0 1 0-8 4 4 0 0 1 0 8z"/>'
  }
})
